var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReimbursement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.499,
    height: 31.499,
    viewBox: "0 0 31.499 31.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription-cashflow",
    transform: "translate(-0.964 -0.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    "data-name": "Vector 3",
    d: "M25.693,17.795A2.7,2.7,0,0,0,23.154,16H21.07a2.4,2.4,0,0,0-.514,4.751l3.173.694a2.693,2.693,0,0,1-.575,5.324H21.359a2.693,2.693,0,0,1-2.539-1.795",
    transform: "translate(-5.543 -4.671)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2489",
    "data-name": "Vector 2489",
    d: "M24,14.692V12",
    transform: "translate(-7.286 -3.363)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2490",
    "data-name": "Vector 2490",
    d: "M24,34.692V32",
    transform: "translate(-7.286 -9.902)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1522",
    "data-name": "Ellipse 1522",
    d: "M32.271,24A15,15,0,0,1,3.422,29.769",
    transform: "translate(-0.558 -7.286)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1523",
    "data-name": "Ellipse 1523",
    d: "M1.714,16.714a15,15,0,0,1,28.849-5.769",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.044,8.571v4.615H39.429",
    transform: "translate(-12.331 -2.242)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.714,37.187V32.571H6.329",
    transform: "translate(0 -10.089)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReimbursement);
export default __webpack_public_path__ + "static/media/reimbursement.dbf2ed7288686ddd48b9d467da969799.svg";
export { ForwardRef as ReactComponent };